var CatalogCtrl = function () {
  this.getFilterData = filterData => {
    this.filterData = filterData.filter(item => item.Type === "price");
  };
};
export default CatalogCtrl;